var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxForm',{attrs:{"show-colon-after-label":false}},[_c('DxGroupItem',[_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('Searcher.observations.name'),"editor-options":{
        onValueChanged: _vm.onChangeName,
      }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }